import { css } from '@linaria/atomic';
import { Icon } from '@frontend/icons';
import { useTooltip } from '@frontend/design-system';

type Props = { label: string; tooltipMessage: string; isArchived?: boolean };

export const HiddenEntityOptionLabel = ({ label, tooltipMessage, isArchived }: Props) => {
  const { Tooltip, triggerProps, tooltipProps } = useTooltip({ trigger: 'hover' });

  return (
    <>
      <span {...triggerProps} css={{ display: 'flex', alignItems: 'center', gap: 'var(--fabric-space-gap-xs)' }}>
        {isArchived && <Icon name='archive-small' color='subdued' css={{ flexShrink: 0 }} />}
        {label}
      </span>
      <Tooltip {...tooltipProps}>{tooltipMessage}</Tooltip>
    </>
  );
};

export const inactiveEntityOptionStyles = css`
  color: var(--fabric-color-text-disabled);
  cursor: not-allowed;
`;
